module.exports = __webpack_public_path__ + "assets/images/8-2HqgGWP.jpeg";